module.exports = __webpack_public_path__ + "img/yl.24c01f3c.jpg";